import React from 'react';
import { Link } from 'react-router';
import Base from 'client/components/base';
import StringStore from 'client/stores/strings';
import baseUrl from 'server/routes/base-url';

export default class ButtonHeader extends Base {
  render() {
    const { url, id } = this.props;
    const label = StringStore.get(`header.${this.props.id}`);

    if (url) {
      return (
        <a className={this.css()} href={url}>
          {label}
        </a>
      );
    }

    return (
      <Link to={`${baseUrl}${id}`} className={this.css()}>
        {label}
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/header/button-header/button-header.es6